<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<div
  id="add-remove-container"
  class="add-remove-container"
  cdkTrapFocus
  tabindex="0"
  (keydown.escape)="ignoreEscapeKeydown($event)"
>
  <div id="adhoc-back-button" class="back-button-overlay">
    <button class="adhoc-back-button-container" (click)="onClickBack()">
      <span class="material-icons adhoc-back-button" id="arrow-left-18" aria-label="back"> arrow_back_ios_new </span>
    </button>
    <div class="ms-font-m back-button-text">{{ ADD_REMOVE_FIELDS | async }}</div>
  </div>
  <div class="add-remove-content">
    @if (isLoading) {
      <lf-loader-component class="lf-adhoc-state-message"></lf-loader-component>
    } @else {
      @if (shouldShowErrorMessage) {
        <div class="lf-adhoc-state-message error-entries-text">{{ AN_ERROR_OCCURED | async }}</div>
      } @else {
        <div class="field-picker-container" [ngClass]="{ 'has-changes': areCheckboxChanges }">
          <div class="search">
            <input [formControl]="filterFieldsControl" placeholder="{{ SEARCH_FIELDS | async }}" class="searchBox" />
            <div class="icon icon-search"></div>
            @if (fieldFilterText && fieldFilterText.length > 0) {
              <div (click)="onClearFields()" class="icon icon-clear"></div>
            }
          </div>
          @if (displayFieldInfos && displayFieldInfos.length > 0) {
            <cdk-virtual-scroll-viewport itemSize="25" class="pick-field">
              <div *cdkVirtualFor="let field of displayFieldInfos; let i = index">
                <mat-checkbox
                  color="primary"
                  class="lf-checkbox"
                  (change)="onUpdateCheckbox($event, field)"
                  id="`add-remove-checkbox-{{ i }}`"
                  [checked]="isFieldSelected(field)"
                  title="{{ field.displayName }}"
                  [disabled]="field.inTemplateSelected"
                >
                  {{ field.displayName }} ({{ field | getFieldType: LOCALIZED_FIELD_TYPES | async }})
                </mat-checkbox>
              </div>
            </cdk-virtual-scroll-viewport>
          } @else {
            <div class="lf-adhoc-state-message fields-empty">
              {{ NO_MATCHING_FIELDS_FOUND | async }}
            </div>
          }
        </div>
      }
    }
  </div>
  @if (areCheckboxChanges) {
    <div class="button-container">
      <div class="button-padding-container">
        <button id="adhoc-apply-button" class="primary-button lf-button adhoc-field-button" (click)="onClickApply()">
          {{ APPLY | async }}
        </button>
        <button id="adhoc-cancel-button" class="sec-button lf-button adhoc-field-button" (click)="onClickCancel()">
          {{ CANCEL | async }}
        </button>
      </div>
    </div>
  }
</div>

<ng-template #addRemoveConfirmModal let-data>
  <lf-popup-modal-component [data]="data" (buttonClick)="onModalButtonClick($event)"></lf-popup-modal-component>
</ng-template>
